<div class="screen">

  <app-theme-header></app-theme-header>

  <div class="screen__stage">
    <span class="outline-button outline-button--hero screen__heading">PROMOTION</span>
    <button type="button" class="outline-button outline-button--secondary"
      (click)="host.openDialog(host.promotiontext, 'promotiontext')">
      TEXT CODE
    </button>
  </div>

  <div class="screen__actions">
    <button type="button" class="outline-button" (click)="host.goToBack()">
      {{ host.TXT_GLOBAL_BACK_BUTTON }}
    </button>
  </div>

</div>
